import request from './index'

// export const entityList = (entityId, pageIndex, pageSize, params, fuzzySearch) => {
export const getRoleNames = entityId => {
  return request({
    url: '/role/get_roles',
    method: 'post',
    data: {
      command_id: 45,
      entityId
    }
  })
}

export const getRoles = entityId=>{
  return request({
    url: '/role/getRolesByEntityId',
    method: 'post',
    data: {
      command_id: 49,
      entityId:entityId
    }
  })
}

export const roleList = listQuery => {
  return request({
    url: '/role/getRolesPage',
    method: 'post',
    data: {
      command_id: 45,
      entityId: listQuery.entityId,
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
      params: listQuery.params,
      fuzzySearch: listQuery.fuzzySearch
    }
  })
}

export const getMenusByRoleId = roleId => {
  return request({
    url: '/role/getMenusByRoleId',
    method: 'post',
    data: {
      command_id: 0,
      roleId:roleId,
    }
  })
}

export const addRole = (role) => {
  return request({
    url: '/role/addRole',
    method: 'post',
    data: {
      command_id: 0,
      role:role
    }
  })
}

export const updateRole = (role) => {
  return request({
    url: '/role/updateRole',
    method: 'post',
    data: {
      command_id: 0,
      role:role
    }
  })
}

export const deleteRole = (roleId) => {
  return request({
    url: '/role/deleteRole',
    method: 'delete',
    data: {
      command_id: 0,
      roleId:roleId,
      role:{}
    }
  })
}

export const updateRoleMenu = (role) => {
  return request({
    url: '/role/updateRoleMenu',
    method: 'post',
    data: {
      command_id: 0,
      role:role
    }
  })
}